import { Tooltip } from "@idui/react-popover";
import { motion } from "motion/react";
import styled from "styled-components";

import type { IStyledAttributes } from "@ryde/shared";
import {
  blueGreyMui,
  deepPurpleMui,
  greyMui,
  MOBILE_BREAKPOINT,
  redMui,
  rydeColors,
  ScreenDepth,
} from "@ryde/theme";

export const FloatingMenuStyled = styled(motion.div).attrs<IStyledAttributes>({
  "data-e2e": "floating-menu",
})`
  height: 70px;
  position: fixed;
  background: ${rydeColors.white};
  padding-inline-start: 15px;
  padding-inline-end: 15px;
  border-radius: 6px;
  border: 1px solid ${blueGreyMui.A100};
  box-shadow: 0 10px 23px rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  z-index: ${ScreenDepth.FLOATING_MENU};
  .grip {
    height: 18px;
    width: 16px;
  }
  .openDrawer {
    margin-inline-start: auto;
    min-width: 28px;
  }
  .selected_count_container {
    font-size: 12px;
    color: ${greyMui._700};
  }

  .grey-text {
    color: ${rydeColors.midGrey};
  }

  .cancel {
    background: ${rydeColors.red};
    border-radius: 4px;
    border-left: 2px solid ${rydeColors.goryRed};

    span {
      margin-inline-start: 5px;
    }
  }

  .archive {
    color: ${redMui.A400};
    font-size: 14px;
    font-weight: 400;
    opacity: 0.3;
  }

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    gap: 20px;

    /* The theme's lineHeight: 0 stacks a wrapped label's lines on top of each other. */
    .MuiButton-root {
      line-height: normal;
    }
  }
`;

export const FloatingMenuButton = styled.button.attrs<IStyledAttributes>({
  "data-e2e": "floating-menu-button",
})`
  display: flex;
  cursor: pointer;
  align-items: center;
  gap: 5px;
  border: none;
  background-color: inherit;
  svg {
    cursor: pointer;
  }
  .greyButton {
    color: ${greyMui._700};
  }
`;

export const FloatingMenuTooltipStyled = styled(
  Tooltip,
).attrs<IStyledAttributes>({
  arrowColor: deepPurpleMui.A400,
  "data-e2e": "floating-menu-tooltip-wrapper",
})`
  background-color: ${deepPurpleMui.A400};
  color: ${rydeColors.white};
  padding: 10px;
`;
